import { apiClient } from './apiClient'

export const applicationGroupApi = {
    fetchApplicationGroups: async (config, accessToken) => {
        const url = `${config.accountServiceBaseUrl}/api/applicationGroups`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET",
                headers: {
                    'ClientId': '3'
                }
            },
            async (response) => {
                return await response.json().then(
                    (rt) => {
                        return rt.applicationGroups
                    }
                )
            }
        )
    }
}